import React, { useEffect, useState } from 'react'
import { useTheme } from '@emotion/react'
import { Helmet } from 'react-helmet'
import { css } from 'src/style/css'
import { isReferencesPage } from 'src/navigation/pages'
// @ts-ignore
import clutchImage from 'src/img/clutch.png'

const clutchProfileUrl = 'https://clutch.co/profile/garwan'

const useIsReferencesPage = () => {
    const [isReferences, setIsReferences] = useState(false)

    useEffect(() => {
        if (isReferencesPage(window.location.pathname)) {
            setIsReferences(true)
        }
    }, [])

    return isReferences
}

export const ClutchImageWidget = () => {
    const isReferences = useIsReferencesPage()
    const th = useTheme()

    return (
        <a
            href={clutchProfileUrl}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Garwan on Clutch"
            css={css`
                display: block;
                position: absolute;
                top: calc(
                    ${th.headerHeight} + ${isReferences ? ' 20px' : ' 12px'}
                );
                right: ${isReferences ? th.spacing.sm : th.spacing.xl};
                width: 80px;
                aspect-ratio: 367 / 290;
                box-sizing: border-box;
                z-index: ${th.zIndex.nav - 1};
                @media (max-width: ${th.mediaQuery.md}) {
                    top: auto;
                    right: 50%;
                    bottom: ${isReferences ? th.spacing.xl : th.spacing.lg};
                    width: 80px;
                    transform: translate(50%, 0);
                }
            `}
        >
            <img
                src={clutchImage}
                alt="Reviewed on Clutch"
                css={css`
                    display: block;
                    width: 100%;
                    height: 100%;
                    object-fit: contain;
                `}
            />
        </a>
    )
}

const ClutchWidget = () => {
    const isReferences = useIsReferencesPage()
    const th = useTheme()

    return (
        <>
            <Helmet>
                <script
                    src="https://widget.clutch.co/static/js/widget.js"
                    key="clutch-script"
                    type="text/javascript"
                    async
                />
            </Helmet>
            <div
                className="clutch-widget"
                id="clutch-widget-small"
                data-url="https://widget.clutch.co"
                data-widget-type="2"
                data-height="60"
                data-expandifr="true"
                {...(isReferences
                    ? { 'data-lightbg': '1' }
                    : { 'data-darkbg': '1' })}
                data-clutchcompany-id="672299"
                css={css`
                    position: absolute;
                    top: calc(
                        ${th.headerHeight} + ${isReferences ? ' 20px' : ' 12px'}
                    );
                    right: ${isReferences ? th.spacing.sm : th.spacing.lg};
                    width: 200px;
                    min-height: 60px;
                    overflow: hidden;
                    z-index: ${th.zIndex.nav - 1};
                    iframe {
                        display: block;
                    }
                    @media (max-width: ${th.mediaQuery.md}) {
                        top: auto;
                        right: 50%;
                        bottom: ${isReferences ? th.spacing.xl : th.spacing.lg};
                        width: min(200px, calc(100vw - ${th.spacing.lg}));
                        transform: translate(50%, 0);
                    }
                `}
            />
        </>
    )
}

export default ClutchWidget
